import React, {useRef} from 'react';

import {useTranslation} from 'react-i18next';

import {CustomFileInput, CustomLink} from 'components/common/XlsxFileForm/styled';
import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Modal} from 'components/ui-kit/Modal';

import {Spinner} from 'components/ui-kit/Spinner';

import {downloadXlsx} from 'utils/downloadXlsx';

import {CustomFileInputContainer, UploadContainer, UploadDescription, UploadFooter} from './styled';

interface Props {
    open: boolean;
    onClose: () => void;
    onFileChange: (file: File | null) => void;
    initialFile?: File | null;
    submit: () => JSX.Element;
    pending?: boolean;
}

export const UploadFileModal = ({
    open,
    onClose,
    onFileChange,
    initialFile,
    submit,
    pending,
}: Props) => {
    const {t} = useTranslation();
    const modalRef = useRef<HTMLDivElement>(null);

    return (
        <Modal
            show={open}
            onClose={onClose}
            closable={!pending}
            title={t('components.upload.title')}
            modalWidth={0}
        >
            <UploadContainer ref={modalRef} tabIndex={-1}>
                <UploadDescription>{t('components.upload.description')}</UploadDescription>
                {pending ? (
                    <Spinner style={{margin: 'auto', height: 75, width: 75}} />
                ) : (
                    <CustomFileInputContainer>
                        <CustomFileInput
                            type="file"
                            initialValue={initialFile?.name ?? ''}
                            label={t('components.form.uploadButton')}
                            onChange={(e) => onFileChange(e.currentTarget.files?.[0] ?? null)}
                            accept=".xlsx,.xls"
                        />
                        <CustomLink
                            style={{cursor: 'pointer'}}
                            onClick={() =>
                                downloadXlsx({
                                    path: '/examples/codes.xlsx',
                                    localePath: 'examples.code',
                                })
                            }
                        >
                            {t('components.xlsxForm.example')}
                        </CustomLink>
                    </CustomFileInputContainer>
                )}
                <UploadFooter>
                    <Button variant={ButtonVariant.Outline} onClick={onClose} disabled={pending}>
                        {t('components.form.Cancel')}
                    </Button>
                    {submit?.()}
                </UploadFooter>
            </UploadContainer>
        </Modal>
    );
};
